import React from 'react';
import { useCanonicalUrl } from '../../hooks/useCanonicalUrl';
import { seoConfig } from '../../lib/seo';

const Gallery: React.FC = () => {
  useCanonicalUrl(seoConfig.gallery);

const galleryImages = [
  { 
    src: 'assets/rolls/auklandEdge.png', 
    title: 'Auckland edge',
    description: 'High contrast film look with warm, punchy tones and sharp definition'
  },
  { 
    src: 'assets/rolls/bangkokTilt.png', 
    title: 'Bangkok tilt',
    description: 'Dramatic contrast with warm yellows and deep blues creating cinematic depth'
  },
  { 
    src: 'assets/rolls/dohaAzure.png', 
    title: 'Doha azure',
    description: 'Cool blue tones with balanced contrast and pristine white highlights'
  },
  { 
    src: 'assets/rolls/osloLight.png', 
    title: 'Oslo light',
    description: 'Blue shadows and orange highlights creating natural contrast balance'
  },
  { 
    src: 'assets/rolls/elpasoHeat.png', 
    title: 'El Paso heat',
    description: 'Soft contrast with bright, warm tones capturing golden desert light'
  },
  { 
    src: 'assets/rolls/jakartaMirage.png', 
    title: 'Jakarta mirage',
    description: 'Rich greenish tones with medium contrast and vibrant color saturation'
  },
  { 
    src: 'assets/rolls/lisbonPearl.png', 
    title: 'Lisbon pearl',
    description: 'Clean white balance with medium contrast and elegant warm undertones'
  },
  { 
    src: 'assets/rolls/japanBW.png', 
    title: 'Japan B&W',
    description: 'Classic black & white with professional film aesthetic and timeless appeal'
  },
  { 
    src: 'assets/rolls/marseilleSnap.png', 
    title: 'Marseille snap',
    description: 'Medium contrast with warm, cinematic tones and vintage film character'
  },
  { 
    src: 'assets/rolls/dublinOvercast.png', 
    title: 'Dublin overcast',
    description: 'Moody greenish atmosphere with soft, muted tones and gentle contrast'
  },
  { 
    src: 'assets/rolls/munichSky.png', 
    title: 'Munich sky',
    description: 'Cool blue tones with subtle desaturation and atmospheric depth'
  },
  { 
    src: 'assets/rolls/parisTone.png', 
    title: 'Paris tone',
    description: 'Azure-blue greens with soft shadows and flattering skin tone rendering'
  },
  { 
    src: 'assets/rolls/santoriniAir.png', 
    title: 'Santorini air',
    description: 'Bright, saturated colors with clean whites and Mediterranean luminosity'
  },
  { 
    src: 'assets/rolls/sevilleGold.png', 
    title: 'Seville gold',
    description: 'Strong contrast with golden yellow tones and rich color definition'
  },
  { 
    src: 'assets/rolls/torontoFlash.png', 
    title: 'Toronto flash',
    description: 'Clean, bright imagery with medium contrast and vivid color pop'
  },
  { 
    src: 'assets/rolls/tucson828.png', 
    title: 'Tucson 828',
    description: 'Bold contrast with bright yellows and dramatic shadow depth'
  },
  { 
    src: 'assets/rolls/mobberleyRed.png', 
    title: 'Mobberley Red',
    description: 'Dystopian scenes with reds and golds inspired by Harman RED 125 film'
  },
  { 
    src: 'assets/rolls/footscraySame.png', 
    title: 'Footscray Same',
    description: 'Vibrant colors with a familiar 400-speed feel, inspired by Same Same But Different.'
  },
  { 
    src: 'assets/rolls/NewYorkNoir.png', 
    title: 'New York Noir',
    description: 'Description'
  },
  { 
    src: 'assets/rolls/oaxacaMint.png', 
    title: 'Oaxaca Mint',
    description: 'Description'
  },
  { 
    src: 'assets/rolls/wetzlarMono.png', 
    title: 'Wetzlar Mono',
    description: 'High-contrast black & white with crushed blacks and sharp tones.'
  }
];

  return (
    <div className="page-container">
      <main className="page-main">
        <header className="page-header">
          <h1>LUT Gallery</h1>
          <p className="page-description">
            Explore the transformative power of our LUT filters. Each image showcases 
            the unique character and mood that our professional-grade filters bring to your photos.
          </p>
        </header>

        <div className="">
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div key={index} className="gallery-item">
                <img 
                  src={image.src} 
                  alt={image.title}
                  className="gallery-image"
                />
                <div className="gallery-info">
                  <h3>{image.title}</h3>
                  <p>{image.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Gallery; 